import { useState } from 'react';

const ProgramsSection = () => {
  const [activeTab, setActiveTab] = useState('main');
  const [selectedCourse, setSelectedCourse] = useState<any>(null);

  const mainCourses = [
    {
      name: '軟式飛盤',
      icon: 'ri-disc-line',
      description: '學習飛盤技巧，培養手眼協調能力',
      details: '透過專業教練指導，學習飛盤的基本投擲技巧、接盤方法及團隊配合。課程包含基礎動作訓練、趣味競賽活動，培養孩子的手眼協調能力與團隊合作精神。',
      benefits: ['提升手眼協調', '培養團隊精神', '增進運動技能', '建立自信心'],
      images: [
        {
          url: 'https://public.readdy.ai/ai/img_res/02c0998bdc0329a69c388ff520c79dfa.jpg',
          caption: '孩子們在戶外練習飛盤投擲技巧'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Professional%20coach%20teaching%20children%20frisbee%20techniques%2C%20kids%20learning%20proper%20throwing%20form%2C%20outdoor%20sports%20field%2C%20educational%20sports%20training%2C%20group%20activity%20with%20instructor%20guidance&width=600&height=400&seq=frisbee2&orientation=landscape',
          caption: '專業教練指導飛盤基本動作'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20team%20frisbee%20competition%2C%20kids%20working%20together%20in%20frisbee%20game%2C%20colorful%20frisbees%20flying%2C%20teamwork%20and%20cooperation%2C%20outdoor%20sports%20activity%2C%20joyful%20children%20playing&width=600&height=400&seq=frisbee3&orientation=landscape',
          caption: '團隊合作的飛盤競賽活動'
        }
      ]
    },
    {
      name: '科學實驗',
      icon: 'ri-flask-line',
      description: '動手做實驗，探索科學奧秘',
      details: '在安全的實驗環境中，孩子將親手操作各種有趣的科學實驗，從化學反應到物理現象，透過實作培養科學思維與探索精神。',
      benefits: ['培養科學思維', '動手實作能力', '觀察力訓練', '激發好奇心'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20conducting%20science%20experiments%20in%20laboratory%2C%20kids%20wearing%20safety%20goggles%2C%20colorful%20chemical%20reactions%2C%20test%20tubes%20and%20beakers%2C%20educational%20science%20class%2C%20hands-on%20learning%20experience&width=600&height=400&seq=science1&orientation=landscape',
          caption: '孩子們在實驗室進行化學實驗'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20doing%20physics%20experiments%20with%20magnets%20and%20electricity%2C%20children%20exploring%20scientific%20phenomena%2C%20educational%20laboratory%20setting%2C%20curious%20expressions%2C%20interactive%20science%20learning&width=600&height=400&seq=science2&orientation=landscape',
          caption: '探索物理現象的實驗活動'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20observing%20microscope%20specimens%2C%20kids%20amazed%20by%20scientific%20discoveries%2C%20laboratory%20equipment%2C%20educational%20science%20exploration%2C%20young%20scientists%20learning%20and%20discovering&width=600&height=400&seq=science3&orientation=landscape',
          caption: '透過顯微鏡觀察科學世界'
        }
      ]
    },
    {
      name: '躲避球',
      icon: 'ri-basketball-line',
      description: '團隊運動，訓練反應與敏捷度',
      details: '經典的團隊運動項目，透過躲避球遊戲訓練孩子的反應速度、敏捷度及團隊戰術配合，在歡樂的氛圍中提升運動能力。',
      benefits: ['反應速度訓練', '敏捷度提升', '團隊合作', '運動精神培養'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20playing%20dodgeball%20in%20gymnasium%2C%20kids%20throwing%20and%20dodging%20balls%2C%20active%20sports%20game%2C%20teamwork%20and%20strategy%2C%20indoor%20sports%20facility%2C%20energetic%20children%20having%20fun&width=600&height=400&seq=dodgeball1&orientation=landscape',
          caption: '體育館內的躲避球競賽'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20practicing%20dodgeball%20techniques%2C%20children%20learning%20agility%20and%20reaction%20skills%2C%20sports%20training%20session%2C%20coach%20instruction%2C%20team%20building%20activity%2C%20athletic%20development&width=600&height=400&seq=dodgeball2&orientation=landscape',
          caption: '躲避球技巧訓練與指導'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20celebrating%20dodgeball%20team%20victory%2C%20kids%20showing%20sportsmanship%20and%20teamwork%2C%20happy%20expressions%20after%20game%2C%20team%20spirit%20and%20cooperation%2C%20sports%20achievement%20celebration&width=600&height=400&seq=dodgeball3&orientation=landscape',
          caption: '團隊合作精神的展現'
        }
      ]
    },
    {
      name: '3D列印',
      icon: 'ri-printer-line',
      description: '學習3D建模與列印技術',
      details: '從3D建模軟體操作開始，學習如何設計自己的作品，並透過3D列印機將創意實體化，培養空間概念與創造力。',
      benefits: ['3D設計能力', '空間概念培養', '創意實現', '科技應用'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%203D%20modeling%20on%20computers%2C%20kids%20designing%20creative%20objects%20on%20screen%2C%20educational%20technology%20class%2C%20digital%20design%20learning%2C%20modern%20classroom%20with%20computers&width=600&height=400&seq=3dprint1&orientation=landscape',
          caption: '學習3D建模軟體操作'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20watching%203D%20printer%20creating%20objects%2C%20children%20amazed%20by%203D%20printing%20process%2C%20colorful%20printed%20models%2C%20technology%20education%2C%20hands-on%20STEM%20learning%20experience&width=600&height=400&seq=3dprint2&orientation=landscape',
          caption: '觀察3D列印機工作過程'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20holding%20their%203D%20printed%20creations%2C%20kids%20proud%20of%20their%20designed%20objects%2C%20colorful%203D%20models%2C%20creative%20achievement%2C%20technology%20and%20art%20combination%2C%20educational%20success&width=600&height=400&seq=3dprint3&orientation=landscape',
          caption: '展示自己設計的3D作品'
        }
      ]
    },
    {
      name: '漆彈生存遊戲',
      icon: 'ri-crosshair-line',
      description: '戰術訓練，培養團隊合作精神',
      details: '在專業教練指導下進行安全的漆彈活動，學習團隊戰術、溝通協調，培養領導力與團隊合作精神。全程配備完善安全裝備。',
      benefits: ['戰術思考', '團隊領導力', '溝通協調', '勇氣培養'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20wearing%20paintball%20safety%20gear%20and%20masks%2C%20kids%20in%20protective%20equipment%2C%20outdoor%20paintball%20field%2C%20safety-focused%20activity%2C%20professional%20supervision%20and%20training&width=600&height=400&seq=paintball1&orientation=landscape',
          caption: '完善的安全防護裝備'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20learning%20paintball%20strategy%20and%20teamwork%2C%20children%20planning%20tactics%20together%2C%20outdoor%20training%20field%2C%20team%20coordination%20exercise%2C%20leadership%20development%20activity&width=600&height=400&seq=paintball2&orientation=landscape',
          caption: '學習團隊戰術與溝通'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20playing%20paintball%20game%20in%20safe%20environment%2C%20kids%20working%20as%20team%20in%20paintball%20activity%2C%20outdoor%20adventure%20course%2C%20courage%20building%20exercise%2C%20supervised%20team%20sport&width=600&height=400&seq=paintball3&orientation=landscape',
          caption: '安全環境下的團隊對抗'
        }
      ]
    },
    {
      name: '點心烘焙',
      icon: 'ri-cake-3-line',
      description: '製作美味點心，學習烘焙技巧',
      details: '在專業烘焙教室中，學習製作各式美味點心，從材料認識、製作流程到成品裝飾，培養生活技能與創意美感。',
      benefits: ['烘焙技能', '創意發揮', '生活能力', '成就感建立'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20baking%20cookies%20and%20cakes%20in%20professional%20kitchen%2C%20kids%20wearing%20aprons%20and%20chef%20hats%2C%20colorful%20ingredients%20and%20baking%20tools%2C%20educational%20cooking%20class%2C%20hands-on%20culinary%20experience&width=600&height=400&seq=baking1&orientation=landscape',
          caption: '專業烘焙教室的製作過程'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20decorating%20cupcakes%20and%20pastries%2C%20children%20using%20colorful%20frosting%20and%20sprinkles%2C%20creative%20cake%20decoration%2C%20artistic%20baking%20skills%2C%20joyful%20cooking%20experience&width=600&height=400&seq=baking2&orientation=landscape',
          caption: '創意點心裝飾與美化'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20proudly%20showing%20their%20baked%20goods%2C%20kids%20holding%20beautiful%20homemade%20cookies%20and%20cakes%2C%20successful%20baking%20results%2C%20achievement%20and%20pride%2C%20delicious%20looking%20pastries&width=600&height=400&seq=baking3&orientation=landscape',
          caption: '展示美味的烘焙成果'
        }
      ]
    },
    {
      name: '競技籃球',
      icon: 'ri-basketball-line',
      description: '籃球技巧訓練與比賽',
      details: '由專業籃球教練指導，學習運球、投籃、傳球等基本技巧，透過分組對抗賽培養競技精神與團隊默契。',
      benefits: ['籃球技巧', '體能訓練', '競技精神', '團隊配合'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20basketball%20dribbling%20skills%2C%20kids%20practicing%20ball%20handling%20with%20coach%2C%20indoor%20basketball%20court%2C%20professional%20sports%20training%2C%20athletic%20skill%20development&width=600&height=400&seq=basketball1&orientation=landscape',
          caption: '籃球基本技巧學習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20playing%20basketball%20game%20on%20court%2C%20children%20hitting%20hoops%20and%20passing%20ball%2C%20team%20competition%2C%20basketball%20match%2C%20athletic%20teamwork%20and%20sportsmanship&width=600&height=400&seq=basketball2&orientation=landscape',
          caption: '分組對抗賽實戰練習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20celebrating%20basketball%20team%20success%2C%20kids%20showing%20team%20spirit%20and%20cooperation%2C%20basketball%20court%20celebration%2C%20sports%20achievement%2C%20teamwork%20and%20friendship&width=600&height=400&seq=basketball3&orientation=landscape',
          caption: '培養競技精神與團隊默契'
        }
      ]
    },
    {
      name: '雷射雕刻',
      icon: 'ri-scissors-cut-line',
      description: '創意設計與雷射雕刻實作',
      details: '學習使用雷射雕刻機，從設計圖稿到實際雕刻，創作獨一無二的作品，培養設計思維與科技應用能力。',
      benefits: ['設計能力', '科技應用', '創意實現', '精細操作'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20designing%20artwork%20on%20computer%20for%20laser%20cutting%2C%20kids%20creating%20digital%20designs%2C%20educational%20technology%20class%2C%20creative%20design%20process%2C%20modern%20digital%20art%20learning&width=600&height=400&seq=laser1&orientation=landscape',
          caption: '數位設計圖稿創作'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20watching%20laser%20cutting%20machine%20in%20action%2C%20children%20observing%20precision%20laser%20engraving%20process%2C%20educational%20technology%20demonstration%2C%20STEM%20learning%20experience%2C%20modern%20manufacturing&width=600&height=400&seq=laser2&orientation=landscape',
          caption: '雷射雕刻機精密操作'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20holding%20their%20laser-cut%20creations%2C%20kids%20proud%20of%20personalized%20engraved%20items%2C%20unique%20handmade%20crafts%2C%20creative%20achievement%2C%20technology%20and%20art%20combination&width=600&height=400&seq=laser3&orientation=landscape',
          caption: '展示獨特的雕刻作品'
        }
      ]
    },
    {
      name: '羽毛球',
      icon: 'ri-ping-pong-line',
      description: '羽球技巧訓練與對打練習',
      details: '學習羽球的握拍、發球、接球等基本技巧，透過對打練習提升反應力與運動技能，培養運動習慣。',
      benefits: ['羽球技巧', '反應力訓練', '體能提升', '運動習慣'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20badminton%20techniques%2C%20kids%20practicing%20proper%20racket%20grip%20and%20stance%2C%20indoor%20badminton%20court%2C%20professional%20sports%20instruction%2C%20athletic%20skill%20development&width=600&height=400&seq=badminton1&orientation=landscape',
          caption: '羽球基本技巧學習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20playing%20badminton%20matches%2C%20children%20hitting%20shuttlecock%20over%20net%2C%20competitive%20badminton%20game%2C%20sports%20training%20session%2C%20athletic%20coordination%20practice&width=600&height=400&seq=badminton2&orientation=landscape',
          caption: '對打練習與技能提升'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20enjoying%20badminton%20recreation%20time%2C%20kids%20having%20fun%20with%20racket%20sports%2C%20active%20lifestyle%20promotion%2C%20healthy%20exercise%20habits%2C%20joyful%20sports%20activity&width=600&height=400&seq=badminton3&orientation=landscape',
          caption: '培養運動習慣與樂趣'
        }
      ]
    }
  ];

  const electiveCourses = [
    {
      name: '數學課程',
      icon: 'ri-calculator-line',
      description: '趣味數學，啟發邏輯思維',
      details: '透過遊戲化的教學方式，讓數學變得有趣又好玩，培養邏輯思維與解決問題的能力，建立數學自信心。',
      benefits: ['邏輯思維', '問題解決', '數學興趣', '自信建立'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20solving%20math%20puzzles%20and%20games%2C%20kids%20working%20with%20colorful%20numbers%20and%20shapes%2C%20interactive%20mathematics%20learning%2C%20educational%20classroom%20setting%2C%20fun%20learning%20activities%2C%20engaging%20math%20education&width=600&height=400&seq=math1&orientation=landscape',
          caption: '趣味數學遊戲與解題'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20using%20math%20manipulatives%20and%20educational%20toys%2C%20children%20building%20with%20geometric%20shapes%2C%20hands-on%20mathematics%20learning%2C%20colorful%20counting%20materials%2C%20interactive%20math%20tools%2C%20creative%20problem%20solving&width=600&height=400&seq=math2&orientation=landscape',
          caption: '動手操作數學教具'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20celebrating%20math%20achievements%2C%20kids%20proud%20of%20solving%20math%20problems%2C%20successful%20learning%20moments%2C%20confidence%20building%20in%20mathematics%2C%20happy%20expressions%2C%20educational%20success&width=600&height=400&seq=math3&orientation=landscape',
          caption: '建立數學自信與成就感'
        }
      ]
    },
    {
      name: '小小廣播',
      icon: 'ri-mic-line',
      description: '培養口語表達與主持能力',
      details: '學習廣播主持技巧、聲音表情運用，透過實際錄音練習，培養自信的口語表達能力與台風。',
      benefits: ['口語表達', '主持技巧', '自信培養', '溝通能力'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20radio%20broadcasting%20skills%2C%20kids%20using%20microphones%20and%20recording%20equipment%2C%20professional%20radio%20studio%20setting%2C%20voice%20training%20session%2C%20communication%20skills%20development&width=600&height=400&seq=radio1&orientation=landscape',
          caption: '專業廣播室錄音練習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20practicing%20public%20speaking%20and%20presentation%2C%20children%20confidently%20speaking%20into%20microphone%2C%20stage%20presence%20training%2C%20oral%20communication%20skills%2C%20confident%20expressions&width=600&height=400&seq=radio2&orientation=landscape',
          caption: '口語表達與台風訓練'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20hosting%20radio%20show%20together%2C%20kids%20working%20as%20team%20in%20broadcasting%2C%20collaborative%20communication%2C%20radio%20program%20production%2C%20teamwork%20in%20media%20creation&width=600&height=400&seq=radio3&orientation=landscape',
          caption: '團隊合作製作廣播節目'
        }
      ]
    },
    {
      name: '英文課程',
      icon: 'ri-english-input',
      description: '互動式英語學習',
      details: '透過遊戲、歌曲、情境對話等互動方式，讓孩子在輕鬆愉快的環境中學習英文，培養語言興趣。',
      benefits: ['英語能力', '聽說訓練', '語言興趣', '國際視野'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20English%20through%20games%20and%20songs%2C%20kids%20singing%20English%20songs%20together%2C%20interactive%20language%20learning%2C%20colorful%20classroom%20environment%2C%20fun%20English%20education%20activities&width=600&height=400&seq=english1&orientation=landscape',
          caption: '透過歌曲遊戲學習英語'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20practicing%20English%20conversation%2C%20children%20role-playing%20in%20English%2C%20situational%20dialogue%20practice%2C%20language%20immersion%20activities%2C%20confident%20English%20speaking&width=600&height=400&seq=english2&orientation=landscape',
          caption: '情境對話與口語練習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20reading%20English%20storybooks%20together%2C%20kids%20enjoying%20English%20literature%2C%20language%20learning%20through%20stories%2C%20educational%20reading%20activities%2C%20international%20language%20development&width=600&height=400&seq=english3&orientation=landscape',
          caption: '英語閱讀與國際視野培養'
        }
      ]
    },
    {
      name: '遙控賽車',
      icon: 'ri-car-line',
      description: '操控遙控車，訓練專注力',
      details: '學習遙控車的操作技巧，透過賽道練習與競速比賽，訓練手眼協調與專注力，體驗速度的樂趣。',
      benefits: ['操控技巧', '專注力訓練', '手眼協調', '競賽體驗'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20remote%20control%20car%20operation%2C%20kids%20practicing%20RC%20car%20driving%20skills%2C%20indoor%20racing%20track%2C%20concentration%20training%2C%20hand-eye%20coordination%20development&width=600&height=400&seq=rccar1&orientation=landscape',
          caption: '學習遙控車操作技巧'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20racing%20remote%20control%20cars%20on%20track%2C%20children%20competing%20in%20RC%20car%20race%2C%20exciting%20racing%20competition%2C%20speed%20and%20precision%20training%2C%20competitive%20spirit%20development&width=600&height=400&seq=rccar2&orientation=landscape',
          caption: '賽道競速比賽體驗'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20maintaining%20and%20customizing%20RC%20cars%2C%20kids%20learning%20technical%20skills%2C%20hands-on%20mechanical%20learning%2C%20problem-solving%20activities%2C%20technical%20education&width=600&height=400&seq=rccar3&orientation=landscape',
          caption: '遙控車維護與技術學習'
        }
      ]
    },
    {
      name: '正音課程',
      icon: 'ri-volume-up-line',
      description: '發音矯正與語言訓練',
      details: '由專業老師進行發音評估與矯正，透過有趣的練習活動，幫助孩子建立正確的發音習慣與清晰的口語表達。',
      benefits: ['發音矯正', '口語清晰', '表達能力', '自信提升'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Professional%20speech%20therapist%20working%20with%20children%2C%20kids%20practicing%20pronunciation%20with%20teacher%2C%20speech%20correction%20training%2C%20language%20development%20session%2C%20individual%20attention&width=600&height=400&seq=speech1&orientation=landscape',
          caption: '專業老師發音指導'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20practicing%20speech%20exercises%2C%20kids%20doing%20pronunciation%20drills%2C%20fun%20speech%20training%20activities%2C%20oral%20communication%20improvement%2C%20clear%20speaking%20practice&width=600&height=400&seq=speech2&orientation=landscape',
          caption: '趣味發音練習活動'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20confidently%20speaking%20with%20improved%20pronunciation%2C%20children%20showing%20clear%20speech%20progress%2C%20successful%20speech%20therapy%20results%2C%20confident%20oral%20expression%2C%20communication%20achievement&width=600&height=400&seq=speech3&orientation=landscape',
          caption: '清晰表達與自信提升'
        }
      ]
    },
    {
      name: '遙控飛機',
      icon: 'ri-plane-line',
      description: '學習飛行原理與操控技巧',
      details: '認識飛行原理，學習遙控飛機的操作技巧，在安全的環境中體驗飛行的樂趣，培養空間概念。',
      benefits: ['飛行知識', '操控技巧', '空間概念', '科學興趣'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20about%20flight%20principles%2C%20kids%20studying%20airplane%20models%20and%20aerodynamics%2C%20educational%20science%20lesson%2C%20aviation%20knowledge%2C%20STEM%20learning%20activities&width=600&height=400&seq=plane1&orientation=landscape',
          caption: '學習飛行原理與科學知識'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20operating%20remote%20control%20airplanes%2C%20children%20flying%20RC%20planes%20in%20safe%20outdoor%20area%2C%20aviation%20hobby%20training%2C%20pilot%20skills%20development%2C%20controlled%20flight%20practice&width=600&height=400&seq=plane2&orientation=landscape',
          caption: '安全環境下的飛行操控'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20excited%20about%20successful%20RC%20plane%20flight%2C%20kids%20celebrating%20aviation%20achievements%2C%20flight%20training%20success%2C%20spatial%20awareness%20development%2C%20aviation%20interest%20cultivation&width=600&height=400&seq=plane3&orientation=landscape',
          caption: '培養空間概念與飛行興趣'
        }
      ]
    },
    {
      name: '小小魔術師',
      icon: 'ri-magic-line',
      description: '魔術表演技巧與創意思考',
      details: '學習各種有趣的魔術技巧，培養表演能力與創意思考，透過魔術表演建立自信與舞台魅力。',
      benefits: ['魔術技巧', '表演能力', '創意思考', '自信建立'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20magic%20tricks%20from%20professional%20magician%2C%20kids%20practicing%20card%20tricks%20and%20illusions%2C%20magic%20education%20class%2C%20entertainment%20skills%20training%2C%20creative%20learning&width=600&height=400&seq=magic1&orientation=landscape',
          caption: '專業魔術師技巧教學'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20performing%20magic%20shows%20for%20audience%2C%20children%20confidently%20presenting%20magic%20tricks%2C%20stage%20performance%2C%20entertainment%20skills%2C%20confidence%20building%20through%20performance&width=600&height=400&seq=magic2&orientation=landscape',
          caption: '舞台表演與自信建立'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20creating%20their%20own%20magic%20tricks%2C%20kids%20using%20creativity%20to%20invent%20illusions%2C%20innovative%20thinking%2C%20problem-solving%20through%20magic%2C%20creative%20expression&width=600&height=400&seq=magic3&orientation=landscape',
          caption: '創意思考與魔術創作'
        }
      ]
    },
    {
      name: '輕黏土拼貼',
      icon: 'ri-palette-line',
      description: '手作藝術，發揮創意想像',
      details: '使用輕黏土創作各種作品，從平面拼貼到立體造型，培養美感與創意，訓練手部精細動作。',
      benefits: ['創意發揮', '美感培養', '精細動作', '藝術興趣'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20working%20with%20colorful%20clay%20and%20crafting%20materials%2C%20kids%20creating%20clay%20sculptures%20and%20art%20pieces%2C%20hands-on%20art%20activities%2C%20creative%20expression%2C%20fine%20motor%20skills%20development&width=600&height=400&seq=clay1&orientation=landscape',
          caption: '彩色黏土創作與雕塑'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20making%20clay%20collages%20and%20mixed%20media%20art%2C%20children%20combining%20different%20materials%20in%20artwork%2C%20artistic%20creativity%2C%20texture%20exploration%2C%20innovative%20art%20techniques&width=600&height=400&seq=clay2&orientation=landscape',
          caption: '拼貼藝術與材質探索'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20proudly%20displaying%20their%20clay%20artwork%2C%20kids%20showing%20finished%20clay%20creations%2C%20artistic%20achievement%2C%20creative%20accomplishment%2C%20handmade%20art%20appreciation&width=600&height=400&seq=clay3&orientation=landscape',
          caption: '展示創意作品與藝術成就'
        }
      ]
    },
    {
      name: '游泳課程',
      icon: 'ri-swim-line',
      description: '游泳技巧訓練與水上安全',
      details: '由合格教練指導，學習游泳技巧與水上安全知識，在安全的泳池環境中培養水性與自救能力。',
      benefits: ['游泳技能', '水上安全', '體能訓練', '自救能力'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20swimming%20techniques%20in%20pool%2C%20kids%20practicing%20swimming%20strokes%20with%20certified%20instructor%2C%20safe%20swimming%20environment%2C%20aquatic%20skills%20development%2C%20water%20safety%20training&width=600&height=400&seq=swim1&orientation=landscape',
          caption: '專業教練游泳技巧指導'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20learning%20water%20safety%20and%20rescue%20techniques%2C%20children%20practicing%20water%20survival%20skills%2C%20swimming%20pool%20safety%20education%2C%20life-saving%20skills%20training%2C%20aquatic%20safety%20awareness&width=600&height=400&seq=swim2&orientation=landscape',
          caption: '水上安全與自救技能'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20enjoying%20swimming%20activities%20and%20water%20games%2C%20kids%20having%20fun%20in%20pool%20while%20building%20swimming%20confidence%2C%20recreational%20swimming%2C%20aquatic%20fitness%2C%20water%20confidence%20building&width=600&height=400&seq=swim3&orientation=landscape',
          caption: '培養水性與游泳樂趣'
        }
      ]
    },
    {
      name: '流行街舞',
      icon: 'ri-music-line',
      description: '街舞律動，展現自我風格',
      details: '學習流行街舞動作，培養節奏感與肢體協調，透過舞蹈展現自我風格，建立自信與表演能力。',
      benefits: ['舞蹈技巧', '節奏感', '肢體協調', '自信展現'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20hip%20hop%20dance%20moves%2C%20kids%20practicing%20street%20dance%20choreography%2C%20dance%20studio%20setting%2C%20rhythm%20and%20coordination%20training%2C%20energetic%20dance%20class&width=600&height=400&seq=dance1&orientation=landscape',
          caption: '街舞基本動作學習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20performing%20street%20dance%20routines%2C%20children%20showing%20dance%20skills%20on%20stage%2C%20confident%20dance%20performance%2C%20self-expression%20through%20movement%2C%20artistic%20dance%20presentation&width=600&height=400&seq=dance2&orientation=landscape',
          caption: '舞台表演與自信展現'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20creating%20their%20own%20dance%20styles%2C%20kids%20expressing%20individuality%20through%20dance%2C%20creative%20movement%2C%20personal%20style%20development%2C%20dance%20creativity%20and%20innovation&width=600&height=400&seq=dance3&orientation=landscape',
          caption: '創造個人舞蹈風格'
        }
      ]
    }
  ];

  const clubActivities = [
    {
      name: '圍巾編織',
      icon: 'ri-scissors-line',
      description: '手工編織，培養耐心與專注',
      details: '學習基本編織技巧，親手編織圍巾等作品，培養耐心、專注力與手部精細動作，完成後可帶回家使用。',
      benefits: ['編織技能', '耐心培養', '專注力', '成就感'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20knitting%20and%20weaving%20techniques%2C%20kids%20working%20with%20colorful%20yarn%20and%20knitting%20needles%2C%20handicraft%20education%2C%20patience%20training%2C%20fine%20motor%20skills%20development&width=600&height=400&seq=knit1&orientation=landscape',
          caption: '學習編織基本技巧'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20concentrating%20on%20knitting%20projects%2C%20children%20focused%20on%20creating%20scarves%20and%20accessories%2C%20detailed%20handwork%2C%20concentration%20training%2C%20mindful%20crafting%20activities&width=600&height=400&seq=knit2&orientation=landscape',
          caption: '專注編織培養耐心'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20proudly%20wearing%20their%20handmade%20scarves%2C%20kids%20showing%20completed%20knitting%20projects%2C%20achievement%20and%20pride%2C%20practical%20life%20skills%2C%20handmade%20accomplishments&width=600&height=400&seq=knit3&orientation=landscape',
          caption: '展示編織成果與成就感'
        }
      ]
    },
    {
      name: '鑽石貼畫',
      icon: 'ri-image-line',
      description: '創意貼畫，訓練細心度',
      details: '使用閃亮的鑽石貼片創作美麗的圖畫，訓練手眼協調與細心度，培養美感與專注力。',
      benefits: ['細心訓練', '美感培養', '專注力', '創意發揮'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20creating%20diamond%20painting%20art%2C%20kids%20placing%20colorful%20diamond%20stickers%20on%20canvas%2C%20detailed%20craft%20work%2C%20precision%20training%2C%20artistic%20creativity%20development&width=600&height=400&seq=diamond1&orientation=landscape',
          caption: '精細鑽石貼畫創作'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20focused%20on%20diamond%20art%20projects%2C%20children%20carefully%20placing%20gems%20to%20create%20patterns%2C%20concentration%20and%20attention%20to%20detail%2C%20mindful%20artistic%20activity&width=600&height=400&seq=diamond2&orientation=landscape',
          caption: '專注力與細心度訓練'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20displaying%20their%20sparkling%20diamond%20paintings%2C%20kids%20proud%20of%20detailed%20artwork%2C%20beautiful%20shimmering%20art%20pieces%2C%20artistic%20achievement%2C%20creative%20accomplishment&width=600&height=400&seq=diamond3&orientation=landscape',
          caption: '閃亮作品展示與美感培養'
        }
      ]
    },
    {
      name: '樂樂棒球',
      icon: 'ri-baseball-line',
      description: '棒球基礎訓練與團隊合作',
      details: '適合兒童的樂樂棒球，學習打擊、接球、跑壘等基本技巧，透過團隊比賽培養合作精神。',
      benefits: ['棒球技巧', '團隊合作', '運動精神', '反應訓練'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20tee%20ball%20basics%2C%20kids%20practicing%20batting%20and%20fielding%20skills%2C%20youth%20baseball%20training%2C%20safe%20sports%20equipment%2C%20fundamental%20baseball%20skills%20development&width=600&height=400&seq=tball1&orientation=landscape',
          caption: '樂樂棒球基本技巧學習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20playing%20tee%20ball%20game%20together%2C%20children%20working%20as%20team%20in%20baseball%2C%20cooperative%20sports%20activity%2C%20teamwork%20and%20sportsmanship%2C%20group%20athletic%20training&width=600&height=400&seq=tball2&orientation=landscape',
          caption: '團隊合作與運動精神'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20celebrating%20tee%20ball%20achievements%2C%20kids%20showing%20team%20spirit%20and%20success%2C%20baseball%20game%20celebration%2C%20sports%20achievement%2C%20athletic%20confidence%20building&width=600&height=400&seq=tball3&orientation=landscape',
          caption: '運動成就與團隊精神展現'
        }
      ]
    },
    {
      name: '疊杯疊疊樂',
      icon: 'ri-stack-line',
      description: '手眼協調與速度訓練',
      details: '透過競技疊杯活動，訓練手眼協調、反應速度與專注力，在趣味競賽中挑戰自我極限。',
      benefits: ['手眼協調', '速度訓練', '專注力', '競賽精神'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20speed%20stacking%20techniques%2C%20kids%20practicing%20cup%20stacking%20patterns%2C%20hand-eye%20coordination%20training%2C%20competitive%20stacking%20sport%2C%20precision%20and%20speed%20development&width=600&height=400&seq=stack1&orientation=landscape',
          caption: '競技疊杯技巧學習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20competing%20in%20speed%20stacking%20competition%2C%20children%20racing%20to%20stack%20cups%20quickly%2C%20competitive%20spirit%2C%20reaction%20time%20training%2C%20exciting%20cup%20stacking%20tournament&width=600&height=400&seq=stack2&orientation=landscape',
          caption: '速度競賽與反應訓練'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20achieving%20personal%20best%20in%20cup%20stacking%2C%20kids%20celebrating%20speed%20stacking%20records%2C%20achievement%20and%20improvement%2C%20competitive%20accomplishment%2C%20skill%20mastery&width=600&height=400&seq=stack3&orientation=landscape',
          caption: '挑戰極限與成就突破'
        }
      ]
    },
    {
      name: '兒童油畫',
      icon: 'ri-brush-line',
      description: '油畫創作，培養藝術美感',
      details: '學習油畫的基本技法，從調色、構圖到創作，培養藝術美感與創意表達能力。',
      benefits: ['繪畫技巧', '美感培養', '創意表達', '藝術興趣'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20oil%20painting%20techniques%2C%20kids%20using%20brushes%20and%20oil%20paints%20on%20canvas%2C%20art%20studio%20setting%2C%20color%20mixing%20and%20painting%20skills%2C%20artistic%20education&width=600&height=400&seq=oil1&orientation=landscape',
          caption: '油畫技法與調色學習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20creating%20oil%20paintings%20of%20landscapes%20and%20still%20life%2C%20children%20expressing%20creativity%20through%20oil%20painting%2C%20artistic%20composition%2C%20creative%20expression%20development&width=600&height=400&seq=oil2&orientation=landscape',
          caption: '創意構圖與藝術表達'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20proudly%20displaying%20their%20oil%20paintings%2C%20kids%20showing%20finished%20artwork%2C%20artistic%20achievement%2C%20beautiful%20painted%20canvases%2C%20art%20appreciation%20and%20accomplishment&width=600&height=400&seq=oil3&orientation=landscape',
          caption: '油畫作品展示與藝術成就'
        }
      ]
    },
    {
      name: '象棋黑白棋',
      icon: 'ri-chess-line',
      description: '策略思考與邏輯訓練',
      details: '學習象棋與黑白棋的規則與策略，透過對弈訓練邏輯思考、策略規劃與專注力。',
      benefits: ['策略思考', '邏輯訓練', '專注力', '耐心培養'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20learning%20chess%20and%20othello%20rules%2C%20kids%20studying%20board%20game%20strategies%2C%20logical%20thinking%20development%2C%20strategic%20planning%20education%2C%20mind%20training%20activities&width=600&height=400&seq=chess1&orientation=landscape',
          caption: '棋類規則與策略學習'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20playing%20chess%20and%20othello%20games%2C%20children%20concentrating%20on%20strategic%20moves%2C%20logical%20thinking%20in%20action%2C%20competitive%20board%20gaming%2C%20mental%20challenge%20activities&width=600&height=400&seq=chess2&orientation=landscape',
          caption: '對弈實戰與邏輯思考'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20analyzing%20chess%20positions%20and%20planning%20strategies%2C%20kids%20developing%20critical%20thinking%20through%20board%20games%2C%20strategic%20analysis%2C%20problem-solving%20skills%20development&width=600&height=400&seq=chess3&orientation=landscape',
          caption: '策略分析與思維訓練'
        }
      ]
    },
    {
      name: '羽毛球',
      icon: 'ri-ping-pong-line',
      description: '羽球運動，增進體能',
      details: '下午時段的羽球活動，透過輕鬆的對打練習，增進體能與運動技巧，培養運動習慣。',
      benefits: ['羽球技巧', '體能訓練', '運動習慣', '反應力'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20playing%20recreational%20badminton%2C%20kids%20enjoying%20afternoon%20badminton%20activities%2C%20relaxed%20sports%20environment%2C%20fitness%20and%20fun%2C%20healthy%20exercise%20habits&width=600&height=400&seq=badminton-club1&orientation=landscape',
          caption: '下午輕鬆羽球活動'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20improving%20badminton%20skills%20through%20practice%2C%20children%20developing%20racket%20sports%20techniques%2C%20athletic%20improvement%2C%20sports%20skill%20enhancement%2C%20active%20lifestyle%20promotion&width=600&height=400&seq=badminton-club2&orientation=landscape',
          caption: '技巧提升與體能訓練'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20forming%20healthy%20exercise%20habits%20through%20badminton%2C%20kids%20enjoying%20regular%20sports%20activity%2C%20fitness%20routine%20development%2C%20active%20recreation%2C%20sports%20enthusiasm&width=600&height=400&seq=badminton-club3&orientation=landscape',
          caption: '培養運動習慣與健康生活'
        }
      ]
    },
    {
      name: '競技籃球',
      icon: 'ri-basketball-line',
      description: '籃球競賽與技巧提升',
      details: '下午的籃球時間，透過分組對抗與技巧練習，提升籃球能力與團隊默契。',
      benefits: ['籃球技巧', '團隊配合', '競技精神', '體能提升'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20playing%20competitive%20basketball%20in%20afternoon%2C%20kids%20practicing%20advanced%20basketball%20skills%2C%20team%20competition%2C%20athletic%20development%2C%20sports%20excellence%20training&width=600&height=400&seq=basketball-club1&orientation=landscape',
          caption: '下午競技籃球訓練'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20working%20on%20basketball%20team%20strategies%2C%20children%20developing%20team%20coordination%2C%20group%20tactics%20training%2C%20basketball%20teamwork%2C%20collaborative%20sports%20skills&width=600&height=400&seq=basketball-club2&orientation=landscape',
          caption: '團隊戰術與默契培養'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20showing%20competitive%20spirit%20in%20basketball%2C%20kids%20demonstrating%20sportsmanship%20and%20athletic%20excellence%2C%20basketball%20achievement%2C%20competitive%20sports%20development&width=600&height=400&seq=basketball-club3&orientation=landscape',
          caption: '競技精神與運動卓越'
        }
      ]
    },
    {
      name: '拼豆',
      icon: 'ri-grid-line',
      description: '拼豆創作，訓練專注力',
      details: '使用彩色拼豆創作各種圖案，訓練手眼協調、色彩搭配與專注力，完成後可帶回家收藏。',
      benefits: ['創意發揮', '專注力', '色彩美感', '精細動作'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20creating%20perler%20bead%20art%2C%20kids%20arranging%20colorful%20beads%20in%20patterns%2C%20detailed%20craft%20work%2C%20concentration%20training%2C%20fine%20motor%20skills%20development&width=600&height=400&seq=beads1&orientation=landscape',
          caption: '彩色拼豆圖案創作'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20focused%20on%20bead%20art%20projects%2C%20children%20carefully%20placing%20beads%20to%20form%20designs%2C%20color%20coordination%20training%2C%20attention%20to%20detail%2C%20mindful%20crafting&width=600&height=400&seq=beads2&orientation=landscape',
          caption: '專注力與色彩搭配訓練'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20proudly%20showing%20their%20finished%20bead%20art%2C%20kids%20displaying%20colorful%20perler%20bead%20creations%2C%20handmade%20keepsakes%2C%20creative%20accomplishment%2C%20artistic%20achievement&width=600&height=400&seq=beads3&orientation=landscape',
          caption: '完成作品展示與收藏'
        }
      ]
    },
    {
      name: '撲克UNO牌',
      icon: 'ri-game-line',
      description: '桌遊娛樂，培養策略思維',
      details: '透過撲克牌與UNO等桌遊，在歡樂的氛圍中培養策略思考、數字概念與社交能力。',
      benefits: ['策略思考', '社交能力', '數字概念', '娛樂放鬆'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20playing%20card%20games%20and%20UNO%20together%2C%20kids%20enjoying%20board%20games%20and%20card%20activities%2C%20social%20interaction%2C%20strategic%20thinking%20development%2C%20fun%20group%20activities&width=600&height=400&seq=cards1&orientation=landscape',
          caption: '桌遊娛樂與社交互動'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20learning%20strategy%20through%20card%20games%2C%20children%20developing%20logical%20thinking%20with%20playing%20cards%2C%20number%20concepts%2C%20strategic%20planning%2C%20educational%20gaming&width=600&height=400&seq=cards2&orientation=landscape',
          caption: '策略思考與數字概念'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20having%20fun%20with%20friends%20playing%20cards%2C%20kids%20laughing%20and%20enjoying%20recreational%20games%2C%20social%20bonding%2C%20relaxation%20and%20entertainment%2C%20friendship%20building&width=600&height=400&seq=cards3&orientation=landscape',
          caption: '歡樂氛圍與友誼建立'
        }
      ]
    },
    {
      name: '漆彈生存遊戲',
      icon: 'ri-crosshair-line',
      description: '團隊戰術與合作訓練',
      details: '下午的漆彈活動，在安全的環境中進行團隊對抗，培養戰術思考與團隊合作能力。',
      benefits: ['團隊合作', '戰術思考', '勇氣培養', '領導力'],
      images: [
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20in%20afternoon%20paintball%20training%2C%20kids%20learning%20teamwork%20through%20paintball%20activities%2C%20safe%20outdoor%20adventure%2C%20team%20building%20exercise%2C%20leadership%20development&width=600&height=400&seq=paintball-club1&orientation=landscape',
          caption: '下午漆彈團隊訓練'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Kids%20developing%20tactical%20thinking%20in%20paintball%2C%20children%20planning%20team%20strategies%2C%20leadership%20skills%20training%2C%20communication%20and%20coordination%2C%20strategic%20team%20activities&width=600&height=400&seq=paintball-club2&orientation=landscape',
          caption: '戰術思考與領導力培養'
        },
        {
          url: 'https://readdy.ai/api/search-image?query=Children%20showing%20courage%20and%20teamwork%20in%20paintball%2C%20kids%20supporting%20each%20other%20in%20team%20challenges%2C%20bravery%20development%2C%20collaborative%20spirit%2C%20team%20achievement&width=600&height=400&seq=paintball-club3&orientation=landscape',
          caption: '勇氣培養與團隊合作精神'
        }
      ]
    }
  ];

  const getCurrentCourses = () => {
    switch (activeTab) {
      case 'main':
        return mainCourses;
      case 'elective':
        return electiveCourses;
      case 'club':
        return clubActivities;
      default:
        return mainCourses;
    }
  };

  const getTabInfo = () => {
    switch (activeTab) {
      case 'main':
        return {
          title: '上午主修課程',
          subtitle: '每週一、三、五上課選1個',
          color: 'emerald'
        };
      case 'elective':
        return {
          title: '上午副修課程',
          subtitle: '每週二、四上課選1個',
          color: 'orange'
        };
      case 'club':
        return {
          title: '下午俱樂部課程',
          subtitle: '豐富多元的下午活動',
          color: 'blue'
        };
      default:
        return {
          title: '上午主修課程',
          subtitle: '每週一、三、五上課選1個',
          color: 'emerald'
        };
    }
  };

  const tabInfo = getTabInfo();
  const currentCourses = getCurrentCourses();

  const handleCourseClick = (course: any) => {
    setSelectedCourse(course);
  };

  const closeModal = () => {
    setSelectedCourse(null);
  };

  return (
    <section id="programs" className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            CMAP運動健康品格夏令營
          </h3>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto px-4">
            每週一至五，每天主修課程、副修課程與俱樂部課程，讓孩子在多元學習中快樂成長
          </p>
        </div>

        {/* 課程分類切換 */}
        <div className="flex justify-center mb-8 sm:mb-12 px-4">
          <div className="inline-flex bg-gray-100 rounded-full p-1 w-full sm:w-auto overflow-x-auto">
            <button
              onClick={() => setActiveTab('main')}
              className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                activeTab === 'main'
                  ? 'bg-emerald-600 text-white shadow-lg'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              上午主修課程
            </button>
            <button
              onClick={() => setActiveTab('elective')}
              className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                activeTab === 'elective'
                  ? 'bg-orange-500 text-white shadow-lg'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              上午副修課程
            </button>
            <button
              onClick={() => setActiveTab('club')}
              className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                activeTab === 'club'
                  ? 'bg-blue-500 text-white shadow-lg'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              下午俱樂部
            </button>
          </div>
        </div>

        {/* 課程標題與說明 */}
        <div className="text-center mb-8 sm:mb-10 px-4">
          <h4 className={`text-2xl sm:text-3xl font-bold mb-2 text-${tabInfo.color}-600`}>
            {tabInfo.title}
          </h4>
          <p className="text-base sm:text-lg text-gray-600">
            {tabInfo.subtitle}
          </p>
        </div>

        {/* 課程卡片網格 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {currentCourses.map((course, index) => (
            <div
              key={index}
              onClick={() => handleCourseClick(course)}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 cursor-pointer"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-${tabInfo.color}-100 rounded-2xl mb-4`}>
                <i className={`${course.icon} text-3xl text-${tabInfo.color}-600`}></i>
              </div>
              <h5 className="text-xl font-bold text-gray-900 mb-2">
                {course.name}
              </h5>
              <p className="text-gray-600 leading-relaxed mb-3">
                {course.description}
              </p>
              <div className="flex items-center text-emerald-600 font-semibold text-sm">
                <span>查看詳情</span>
                <i className="ri-arrow-right-line ml-1"></i>
              </div>
            </div>
          ))}
        </div>

        {/* 報名提示 */}
        <div className="mt-12 sm:mt-16 text-center bg-gradient-to-r from-emerald-50 to-blue-50 rounded-2xl p-6 sm:p-8">
          <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
            課程選擇說明
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 max-w-4xl mx-auto">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-3">
                <i className="ri-calendar-check-line text-2xl text-emerald-600"></i>
              </div>
              <h5 className="font-bold text-gray-900 mb-2">主修課程</h5>
              <p className="text-sm text-gray-600">每週一、三、五上課，從9個課程中選擇1個</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-3">
                <i className="ri-calendar-line text-2xl text-orange-500"></i>
              </div>
              <h5 className="font-bold text-gray-900 mb-2">副修課程</h5>
              <p className="text-sm text-gray-600">每週二、四上課，從10個課程中選擇1個</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-3">
                <i className="ri-time-line text-2xl text-blue-500"></i>
              </div>
              <h5 className="font-bold text-gray-900 mb-2">俱樂部課程</h5>
              <p className="text-sm text-gray-600">每天下午，豐富多元的活動選擇</p>
            </div>
          </div>
        </div>
      </div>

      {/* 課程詳情彈窗 */}
      {selectedCourse && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-2 sm:p-4"
          onClick={closeModal}
        >
          <div 
            className="bg-white rounded-2xl sm:rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 bg-gradient-to-r from-emerald-500 to-blue-500 text-white p-4 sm:p-6 rounded-t-2xl sm:rounded-t-3xl">
              <div className="flex items-start justify-between">
                <div className="flex items-center flex-1 min-w-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-white/20 rounded-2xl mr-3 sm:mr-4 flex-shrink-0">
                    <i className={`${selectedCourse.icon} text-2xl sm:text-4xl text-white`}></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-lg sm:text-2xl font-bold mb-1 truncate">{selectedCourse.name}</h3>
                    <p className="text-sm sm:text-base text-white/90 line-clamp-2">{selectedCourse.description}</p>
                  </div>
                </div>
                <button
                  onClick={closeModal}
                  className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-all cursor-pointer ml-2 sm:ml-4 flex-shrink-0"
                >
                  <i className="ri-close-line text-xl sm:text-2xl"></i>
                </button>
              </div>
            </div>

            <div className="p-4 sm:p-6 md:p-8">
              {/* 課程圖片展示 */}
              {selectedCourse.images && (
                <div className="mb-6 sm:mb-8">
                  <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 flex items-center">
                    <i className="ri-image-line text-emerald-600 mr-2"></i>
                    課程活動照片
                  </h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                    {selectedCourse.images.map((image: any, index: number) => (
                      <div key={index} className="bg-gray-50 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all">
                        <img 
                          src={image.url} 
                          alt={image.caption}
                          className="w-full h-40 sm:h-48 object-cover object-top"
                        />
                        <div className="p-2 sm:p-3">
                          <p className="text-xs sm:text-sm text-gray-700 font-medium">{image.caption}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-file-text-line text-emerald-600 mr-2"></i>
                  課程介紹
                </h4>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  {selectedCourse.details}
                </p>
              </div>

              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 flex items-center">
                  <i className="ri-star-line text-emerald-600 mr-2"></i>
                  課程效益
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                  {selectedCourse.benefits.map((benefit: string, index: number) => (
                    <div key={index} className="flex items-center bg-emerald-50 rounded-xl p-2 sm:p-3">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-emerald-500 rounded-lg mr-2 sm:mr-3 flex-shrink-0">
                        <i className="ri-check-line text-white text-sm sm:text-lg"></i>
                      </div>
                      <span className="text-sm sm:text-base text-gray-800 font-medium">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-gradient-to-r from-emerald-50 to-blue-50 rounded-2xl p-4 sm:p-6">
                <div className="flex items-start">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-emerald-500 rounded-xl mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-information-line text-white text-lg sm:text-2xl"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-2 text-sm sm:text-base">報名資訊</h5>
                    <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">
                      想了解更多課程詳情或進行報名？歡迎點擊右下角的AI助理，我們將為您提供完整的課程資訊與報名協助！
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row gap-2 sm:gap-3">
                <button
                  onClick={() => {
                    closeModal();
                    const registerSection = document.getElementById('register');
                    if (registerSection) {
                      registerSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="flex-1 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white py-3 sm:py-4 rounded-xl font-bold hover:from-emerald-600 hover:to-emerald-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap text-sm sm:text-base"
                >
                  立即報名
                </button>
                <button
                  onClick={closeModal}
                  className="sm:flex-initial px-6 py-3 sm:py-4 bg-gray-100 text-gray-700 rounded-xl font-bold hover:bg-gray-200 transition-all cursor-pointer whitespace-nowrap text-sm sm:text-base"
                >
                  關閉
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProgramsSection;